import React, { memo } from 'react'

import {
  Button,
  Icon,
  RotatingSpinner,
  Upload2,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import useThreeDModelUploader from './Hooks/useThreeDModelUploader'

function UploadThreeDModelButton({
  withLabel = false,
  subtle = false,
  tooltipId = undefined,
  className = undefined,
}) {
  const t = useTranslation()
  const {
    acceptedExtensions,
    inputRef,
    isLoading,
    onFileChange,
    onFileClick,
  } = useThreeDModelUploader()

  const label = isLoading ? t('shared.uploadModel.uploading') : t('shared.uploadModel.upload')

  const button = (
    <Button
      type={subtle ? 'ghost' : 'secondary'}
      variant={withLabel ? 'with-icon' : 'only-icon'}
      icon={(
        <Icon
          svgComponent={isLoading ? RotatingSpinner : Upload2}
          size="small"
          notSpaced={!withLabel}
          className={classnames(
            'header__button-icon',
            subtle ? 'header__button-icon--light' : 'header__button-icon--dark',
          )}
        />
      )}
      size={subtle ? 'tiny' : 'small'}
      customClass={classnames('header__button', className)}
      onClick={!isLoading ? onFileClick : undefined}
      aria-label={label}
    >
      {withLabel ? label : null}
    </Button>
  )

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={acceptedExtensions.map(ext => `.${ext}`).join(',')}
        onChange={!isLoading ? onFileChange : undefined}
        aria-hidden
        tabIndex={-1}
        disabled={isLoading}
        style={{ display: 'none' }}
      />
      {tooltipId ? (
        <DesktopOnlyTooltip
          content={label}
          id={tooltipId}
          place="bottom"
          containerClass="upload-model-tooltip"
          className="upload-model-tooltip__trigger"
        >
          {button}
        </DesktopOnlyTooltip>
      ) : button}
    </>
  )
}

UploadThreeDModelButton.propTypes = {
  withLabel: bool,
  subtle: bool,
  tooltipId: string,
  className: string,
}

export default memo(UploadThreeDModelButton)
